import { z } from 'zod';
import { c } from '../../contract';

export const userProfile = z
  .object({
    username: z.string().nullable(),
    avatarUrlPath: z.string().nullable(),
    isUsernameAutoGenerated: z.boolean().nullable(),
    profileUpdatePromptCount: z.number().nullable(),
    isUserHasActiveSubscription: z.boolean().nullable(),
  })
  .optional();

export const userProfileRouter = c.router(
  {
    addProfileData: {
      summary: 'Add user profile data',
      method: 'POST',
      path: '/add-profile',
      body: z.object({
        username: z.string(),
        avatarUrlPath: z.string().optional(),
        isUsernameAutoGenerated: z.boolean().optional(),
        profileUpdatePromptCount: z.number().optional(),
        dateOfBirth: z.string().optional(),
      }),
      responses: {
        201: z.object({
          userProfileData: userProfile.optional(),
          message: z.string(),
        }),
      },
    },
    setUserBirthday: {
      summary: 'Add user profile data',
      method: 'POST',
      path: '/set-birthday',
      body: z.object({
        birthday: z.string(),
      }),
      responses: {
        200: z.object({
          userProfileData: userProfile,
          message: z.string(),
        }),
        404: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/user-profiles',
  },
);
